import { useDispatch, useSelector } from "react-redux";
import Modal from "../../UI/Modal";
import { closeAccionFormModal, openAccionViewModal } from "../../../store/reducers/fortalezas/fortalezasPlantel.reducer";
import { useEffect, useState } from "react";
import { updateAccionDesarrolloPlantelThunk, getAccionesDesarrolloPlantelThunk, getAccionDesarrolloPlantelByIdThunk } from "../../../store/reducers/fortalezas/fortalezasPlantel.thunks";
import Loader from "../../UI/Loader";
import Alert from "../../UI/Alert";
import Select2 from "../../UI/Select2";
import { getAreasSelectoresPlantelService } from "../../../services/fortalezas/fortalezasPlantel.service";
import { getTalentosSelectoresPlantelService } from "../../../services/planteles/talentosPlantel.service";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";

const AccionFormModalPlantel = () => {
  const dispatch = useDispatch();
  const { plantelId } = useParams();
  const { accionFormModalOpen, accionFormMode, selectedAccion, accionFormLoading, accionFormError, accionesPage, accionesSearch, accionesFilterArea, accionesFilterTalento } = useSelector((state) => state.fortalezasPlantel);

  const [formData, setFormData] = useState({ frase: "", area: null, talento: null });

  useEffect(() => {
    if (accionFormMode === "edit" && selectedAccion) {
      setFormData({ frase: selectedAccion.frase || "", area: selectedAccion.area || null, talento: selectedAccion.talento || null });
    }
  }, [accionFormMode, selectedAccion, accionFormModalOpen]);

  const handleChange = (e) => setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));

  const fetchAreas = async (searchTerm) => {
    const response = await getAreasSelectoresPlantelService(plantelId, searchTerm);
    return response.map((item) => ({ id: item.id, label: item.label || item.area }));
  };

  const fetchTalentos = async (searchTerm) => {
    const response = await getTalentosSelectoresPlantelService(plantelId, searchTerm);
    return response.map((item) => ({ id: item.id, label: item.label }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const result = await dispatch(updateAccionDesarrolloPlantelThunk({ id: selectedAccion.id, payload: formData }));
    if (result.meta.requestStatus === "fulfilled") {
      dispatch(getAccionesDesarrolloPlantelThunk({ plantelId, page: accionesPage, search: accionesSearch, area: accionesFilterArea, talento: accionesFilterTalento }));
      toast.success("Acción actualizada exitosamente");
      await dispatch(getAccionDesarrolloPlantelByIdThunk(selectedAccion.id));
      dispatch(openAccionViewModal());
    }
  };

  return (
    <Modal open={accionFormModalOpen} onClose={() => dispatch(closeAccionFormModal())} title="Editar acción" size="lg">
      {accionFormLoading ? <Loader center type="dots" text="Actualizando..." /> : (
        <form onSubmit={handleSubmit}>
          {accionFormError && <Alert message={accionFormError} variant="error" />}
          <div className="mb-3">
            <label className="form-label fw-medium">Acción / Frase <span className="text-danger">*</span></label>
            <textarea className="form-control" name="frase" value={formData.frase} onChange={handleChange} placeholder="Ingrese la acción o frase" rows="4" required />
          </div>
          <div className="mb-3">
            <label className="form-label fw-medium">Área de desarrollo <span className="text-danger">*</span></label>
            <Select2 value={formData.area} onChange={(v) => setFormData((prev) => ({ ...prev, area: v || null }))} fetchOptions={fetchAreas} placeholder="Selecciona un área" />
          </div>
          <div className="mb-3">
            <label className="form-label fw-medium">Talento</label>
            <Select2 value={formData.talento} onChange={(v) => setFormData((prev) => ({ ...prev, talento: v || null }))} fetchOptions={fetchTalentos} placeholder="Selecciona un talento" />
          </div>
          <div className="d-flex justify-content-end gap-2">
            <button type="button" className="btn btn-secondary" onClick={() => dispatch(closeAccionFormModal())}>Cancelar</button>
            <button type="submit" className="btn btn-primary">Guardar cambios</button>
          </div>
        </form>
      )}
    </Modal>
  );
};

export default AccionFormModalPlantel;
